module.exports = __webpack_public_path__ + "static/media/SuleimanHani.8459f395.jpg";